import { render, staticRenderFns } from "./FirstPart.vue?vue&type=template&id=3870ac70&scoped=true"
import script from "./FirstPart.vue?vue&type=script&lang=js"
export * from "./FirstPart.vue?vue&type=script&lang=js"
import style0 from "./FirstPart.vue?vue&type=style&index=0&id=3870ac70&prod&scoped=true&lang=css"
import style1 from "./firstPartCss/max.css?vue&type=style&index=1&id=3870ac70&prod&scoped=true&lang=css&external"
import style2 from "./firstPartCss/middle.css?vue&type=style&index=2&id=3870ac70&prod&scoped=true&lang=css&external"
import style3 from "./firstPartCss/flat.css?vue&type=style&index=3&id=3870ac70&prod&scoped=true&lang=css&external"
import style4 from "./firstPartCss/min.css?vue&type=style&index=4&id=3870ac70&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3870ac70",
  null
  
)

export default component.exports